import { List } from '@material-ui/core'
import ExpansionPanel, {
  ExpansionPanelProps,
} from '@material-ui/core/ExpansionPanel'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import withStyles from '@material-ui/core/styles/withStyles'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import React from 'react'

interface IExpansion extends ExpansionPanelProps {
  children: any
  summary?: any
  expansion?: boolean
  customColor?: boolean
  customColorCode?: string
  className?: string
  backColor?: any
  headerColor?: any
  onClick?: any
}
export default function LeftIconCardExpansion({
  summary,
  children,
  expansion,
  customColor,
  customColorCode,
  className,
  backColor,
  headerColor,
  onClick,
  ...props
}: IExpansion) {
  // const [expanded, setExpanded] = React.useState<string | false>(expansion)
  const [expanded, setExpanded] = React.useState<boolean>(false)

  const handleChange = (panel?: string) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean
  ) => {
    // setExpanded(isExpanded ? panel : false)
    setExpanded(isExpanded)
  }

  return (
    <ExpansionPanel
      {...props}
      className={'expand-card ' + className}
      elevation={0}
      onClick={e => e.stopPropagation()}
      style={{ backgroundColor: backColor ?? null, borderRadius: '4px' }}
      expanded={expanded}
      onChange={handleChange()}
    >
      <LeftIconExpansionSummary
        style={{
          backgroundColor: customColorCode ?? 'white',
          paddingLeft: '1.5vw',
        }}
        expandIcon={<KeyboardArrowDownIcon onClick={onClick} />}
        IconButtonProps={{ edge: 'end' }}
      >
        <List
          className={'core-list'}
          style={{ backgroundColor: customColorCode ?? 'white' }}
        >
          {summary}
        </List>
      </LeftIconExpansionSummary>
      <ExpansionPanelDetails style={{ display: 'block' }}>
        {children}
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}

const LeftIconExpansionSummary = withStyles({
  expandIcon: { order: -1 },
})(ExpansionPanelSummary)
